<template>
    <NuxtLoadingIndicator />
    <DynamicDialog />

    <AppConfirmDialog />

    <div class="min-h-screen">
        <SkipLink :inert="drawerIsOpen" />

        <TrustSidebar />

        <main id="main-content" tabindex="-1" :inert="drawerIsOpen" class="nuxt-page-view" :class="{ mobile: isMobile }">
            <div class="2xl:max-w-screen-2xl 2xl:mx-auto">
                <NuxtPage />
            </div>
        </main>
    </div>
</template>

<script setup lang="ts">
import TrustSidebar from '~/components/layout/TrustSidebar.vue'
import SkipLink from '~/components/layout/SkipLink.vue';
import DynamicDialog from 'primevue/dynamicdialog';
import AppConfirmDialog from '~/components/layout/AppConfirmDialog.vue';
import { useMobileStore } from '~/stores/layout/mobile';

const { isMobile } = useIsMobile();
const mobileStore = useMobileStore();
const drawerIsOpen = computed(() => isMobile.value && mobileStore.isMobileNavOpen);
</script>

<style lang="scss" scoped>
.nuxt-page-view {
    margin-left: 280px;
    transition: margin-left 0.3s ease-in-out;

    &.mobile {
        @apply ml-0;
    }

    @media screen and (max-width: 1023.98px) {
        @apply ml-0;
    }
}
</style>
